module.exports = __webpack_public_path__ + "img/banner-mb.f76b070.webp";